export { ShareServiceClient } from './ShareServiceClient';
export type { ShareClient } from './ShareServiceClient';
